module.exports = __webpack_public_path__ + "img/dnz-projects.36891256.png";